@if (vm$ | async; as vm) {
  <p-panel class="secondary-panel">
    <ng-template pTemplate="header">
      <div class="d-flex justify-content-between align-items-center flex-fill">
        <span>Combined Housing Expenses Information</span>
      </div>
    </ng-template>
    <form [formGroup]="expensesForm">
      <p-table [value]="[1]" class="stack">
        <ng-template #inputCurrency let-controlId="controlId" let-automationId="automationId" let-formControl="formControl">
          <p-inputNumber
            [id]="controlId"
            [attr.automation-id]="automationId"
            [formControl]="formControl"
            styleClass="input-span w-100"
            mode="currency"
            placeholder="$0.00"
            currency="USD"
            locale="en-US"
            [min]="0"
            [max]="99999999999.99"
            maxlength="14"
            [minFractionDigits]="2"
            (onBlur)="onInputBlur(controlId, formControl)"
          />
        </ng-template>
        <ng-template #inputFactor let-controlId="controlId" let-automationId="automationId" let-formControl="formControl">
          <cmg-decimal-input
            [id]="controlId"
            [formControl]="formControl"
            placeholder="0.000"
            fractionDigits="3"
            type="percent"
            max="100"
            min="0"
            styleClass="form-control input-span w-100"
            (onBlur)="onInputBlur(controlId, formControl)"
          />
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th class="col-3">Expense Category</th>
            <th class="col-4">Present Monthly Housing</th>
            <th class="col-4">Proposed Monthly Housing</th>
            <th class="col-1">Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body">
          <tr>
            <td>
              <div>Rent</div>
            </td>
            <td class="present-expense-col">
              <ng-container
                *ngTemplateOutlet="
                  inputCurrency;
                  context: { automationId: 'present-rent-present-amount', formControl: expensesForm.get('presentRent') }
                "
              />
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>First Mortgage (P & I)</td>
            <td class="present-expense-col">
              <ng-container
                *ngTemplateOutlet="
                  inputCurrency;
                  context: {
                    automationId: 'first-mortgage-present-amount',
                    formControl: expensesForm.get(['firstMortgage', 'presentAmount']),
                  }
                "
              />
            </td>
            <td>
              <ng-container
                *ngTemplateOutlet="
                  inputCurrency;
                  context: {
                    automationId: 'first-mortgage-proposed-amount',
                    formControl: expensesForm.get(['firstMortgage', 'proposedAmount']),
                  }
                "
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td>Subordinate Lien(s) (P & I)</td>
            <td class="present-expense-col">
              <ng-container
                *ngTemplateOutlet="
                  inputCurrency;
                  context: {
                    automationId: 'other-mortgage-present-amount',
                    formControl: expensesForm.get(['otherMortgage', 'presentAmount']),
                  }
                "
              />
            </td>
            <td>
              <ng-container
                *ngTemplateOutlet="
                  inputCurrency;
                  context: {
                    automationId: 'other-mortgage-proposed-amount',
                    formControl: expensesForm.get(['otherMortgage', 'proposedAmount']),
                  }
                "
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td>Homeowner's Insurance</td>
            <td class="present-expense-col">
              @if (expensesForm.get(['hazardInsurance', 'presentAmount']); as ctrl) {
                <p-inputgroup>
                  <ng-container
                    *ngTemplateOutlet="
                      inputCurrency;
                      context: {
                        automationId: 'hazard-insurance-present-amount',
                        formControl: ctrl,
                      }
                    "
                  />
                  <p-inputgroup-addon>
                    <p-button
                      type="button"
                      [disabled]="isFullyDisabled$ | async"
                      (click)="openCalculatorModal(ctrl.value, 'presentAmount')"
                      icon="pi pi-calculator"
                    />
                  </p-inputgroup-addon>
                </p-inputgroup>
              }
            </td>
            <td>
              @if (expensesForm.get(['hazardInsurance', 'proposedAmount']); as ctrl) {
                <p-inputgroup>
                  <ng-container
                    *ngTemplateOutlet="
                      inputCurrency;
                      context: {
                        automationId: 'hazard-insurance-proposed-amount',
                        formControl: ctrl,
                      }
                    "
                  />
                  <p-inputgroup-addon>
                    <p-button
                      type="button"
                      [disabled]="isFullyDisabled$ | async"
                      (click)="openCalculatorModal(ctrl.value, 'proposedAmount')"
                      icon="pi pi-calculator"
                    />
                  </p-inputgroup-addon>
                </p-inputgroup>
              }
            </td>
            <td></td>
          </tr>
          <tr>
            <td>Supplemental Property Insurance</td>
            <td class="present-expense-col">
              <ng-container
                *ngTemplateOutlet="
                  inputCurrency;
                  context: {
                    automationId: 'property-insurance-present-amount',
                    formControl: expensesForm.get(['propertyInsurance', 'presentAmount']),
                  }
                "
              />
            </td>
            <td>
              <ng-container
                *ngTemplateOutlet="
                  inputCurrency;
                  context: {
                    automationId: 'property-insurance-proposed-amount',
                    formControl: expensesForm.get(['propertyInsurance', 'proposedAmount']),
                  }
                "
              />
            </td>
            <td></td>
          </tr>
          <tr>
            <td>Property Taxes</td>
            <td class="present-expense-col">
              <ng-container
                *ngTemplateOutlet="
                  inputCurrency;
                  context: {
                    automationId: 'real-estate-taxes-present-amount',
                    formControl: expensesForm.get(['realEstateTaxes', 'presentAmount']),
                  }
                "
              />
            </td>
            <td>
              <div class="d-flex">
                <div class="col-3">Factor %</div>
                <div class="col-4 p-r-0">
                  <ng-container
                    *ngTemplateOutlet="
                      inputFactor;
                      context: {
                        controlId: 'real-estate-taxes-factor',
                        automationId: 'real-estate-taxes-factor',
                        formControl: expensesForm.get(['realEstateTaxes', 'factor']),
                      }
                    "
                  />
                </div>
                <div class="col-5 p-r-0">
                  <ng-container
                    *ngTemplateOutlet="
                      inputCurrency;
                      context: {
                        controlId: 'real-estate-taxes-proposed-amount',
                        automationId: 'real-estate-taxes-proposed-amount',
                        formControl: expensesForm.get(['realEstateTaxes', 'proposedAmount']),
                      }
                    "
                  />
                  <cmg-validator-messages [control]="expensesForm.get(['realEstateTaxes', 'proposedAmount'])" />
                </div>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>Mortgage Insurance</td>
            <td class="present-expense-col">
              <ng-container
                *ngTemplateOutlet="
                  inputCurrency;
                  context: {
                    automationId: 'mortgage-insurance-present-amount',
                    formControl: expensesForm.get(['mortgageInsurance', 'presentAmount']),
                  }
                "
              />
            </td>
            <td>
              <div class="d-flex">
                <div class="col-3">Factor %</div>
                <div class="col-4 p-r-0">
                  <ng-container
                    *ngTemplateOutlet="
                      inputFactor;
                      context: {
                        formControl: expensesForm.get(['mortgageInsurance', 'factor']),
                      }
                    "
                  />
                </div>
                <div class="col-5 p-r-0">
                  <ng-container
                    *ngTemplateOutlet="
                      inputCurrency;
                      context: {
                        automationId: 'mortgage-insurance-proposed-amount',
                        formControl: expensesForm.get(['mortgageInsurance', 'proposedAmount']),
                      }
                    "
                  />
                </div>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>Association / Project Dues</td>
            <td class="present-expense-col"></td>
            <td>
              <ng-container
                *ngTemplateOutlet="
                  inputCurrency;
                  context: {
                    automationId: 'home-owner-assn-dues-proposed-amount',
                    formControl: expensesForm.get(['homeOwnerAssnDues', 'proposedAmount']),
                  }
                "
              />
            </td>
            <td></td>
          </tr>
          <tr class="stripedRow">
            <td>Others (Supplemental Property Insurance Included)</td>
            <td class="present-expense-col">
              <ng-container
                *ngTemplateOutlet="
                  inputCurrency;
                  context: {
                    automationId: 'others-total-property-insurance-present-amount',
                    formControl: expensesForm.get(['othersTotalPropertyInsurance', 'presentAmount']),
                  }
                "
              />
            </td>
            <td></td>
            <td></td>
          </tr>
          <ng-container formArrayName="otherHousingExpenses">
            @for (otherExpense of otherHousingExpenses.controls; track otherExpense; let i = $index; let last = $last) {
              <tr class="stripedRow">
                <td>
                  @if (i === 0) {
                    <span>Other</span>
                  }
                </td>
                <td class="present-expense-col"></td>
                <td>
                  <div class="d-flex">
                    <div class="col-6">
                      <p-select
                        [options]="vm.otherExpenseDropdownOptions"
                        [formControl]="otherExpense.controls.expenseType"
                        placeholder="Select Other Expense"
                        optionLabel="name"
                        optionValue="id"
                        optionDisabled="optionDisabled"
                        styleClass="w-100 expenses-dropdown"
                        appendTo="body"
                      />
                    </div>
                    <div class="col-6">
                      <ng-container
                        *ngTemplateOutlet="
                          inputCurrency;
                          context: {
                            automationId: 'other-housing-expenses-' + i + '-proposed-amount',
                            formControl: otherExpense.controls.proposedAmount,
                          }
                        "
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <div class="d-flex">
                    <div class="col-9">
                      @if (otherExpense.controls.expenseType.value === 7) {
                        <div class="d-flex actions-checkbox">
                          <p-checkbox class="d-inline-block" [binary]="true" [formControl]="expensesForm.get('isIncludedInPiti')" />
                          <label class="control-label mb-2 d-inline-block">Impound</label>
                        </div>
                      }
                    </div>
                    <div class="col-3">
                      @if (otherHousingExpenses.controls.length > 1) {
                        <p-button
                          type="button"
                          severity="danger"
                          [attr.automation-id]="'btn-delete-other-housing-expenses-' + i"
                          [disabled]="isFullyDisabled$ | async"
                          (click)="deleteOtherExpenseRow(i)"
                          icon="pi pi-trash"
                        />
                      }
                    </div>
                  </div>
                </td>
              </tr>
            }
            <tr class="stripedRow">
              <td></td>
              <td class="present-expense-col"></td>
              <td>
                <button
                  pButton
                  type="button"
                  severity="secondary"
                  size="small"
                  [attr.automation-id]="'btn-add-other-housing-expenses-' + i"
                  [disabled]="vm.isFullyDisabled"
                  (click)="addOtherExpenseRow()"
                >
                  <i class="pi pi-plus-circle"></i>&nbsp;&nbsp;Add Other Insurance
                </button>
              </td>
              <td></td>
            </tr>
          </ng-container>
          <tr class="stripedRow">
            <td></td>
            <td class="present-expense-col"></td>
            <td>
              @if (expensesForm.get(['othersTotal', 'proposedAmount']); as ctrl) {
                <div class="pull-right">Other Subtotal: {{ '$' + (ctrl.value || 0 | number: '1.2-2') }}</div>
              }
            </td>
            <td></td>
          </tr>
          <tr class="FooterTitle">
            <td>Total Monthly Payment</td>
            <td class="present-expense-col totalTitle">
              @if (expensesForm.get(['total', 'presentAmount']); as ctrl) {
                <div class="pull-right">
                  {{ '$' + (ctrl.value || 0 | number: '1.2-2') }}
                </div>
              }
            </td>
            <td class="totalTitle">
              @if (expensesForm.get(['total', 'proposedAmount']); as ctrl) {
                <div class="pull-right">
                  {{ '$' + (ctrl.value || 0 | number: '1.2-2') }}
                </div>
              }
            </td>
            <td></td>
          </tr>
        </ng-template>
      </p-table>
    </form>
  </p-panel>
  <!-- Modal: Calculator -->
  <p-dialog
    header="Homeowner's Insurance Calculator"
    [(visible)]="showCalculatorModal"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    styleClass="expenses-dialog expenses-dialog--calculator"
    (onHide)="closeCalculatorModal()"
  >
    <div class="calc-modal-subheader mb-3">{{ calculatorColumnName === 'presentAmount' ? 'Present' : 'Proposed' }}</div>
    <form [formGroup]="calculatorModalForm">
      <div [attr.automation-id]="'calculatorModalMonthly' | qaSlug">
        <label for="monthlyPayment" class="control-label mb-2">Monthly Payment</label>
        <p-inputNumber
          data-private
          #monthlyPaymentInput
          id="monthlyPayment"
          formControlName="monthlyPayment"
          styleClass="form-control input-span w-100 mb-3"
          mode="currency"
          placeholder="$0.00"
          currency="USD"
          locale="en-US"
          [min]="0"
          [max]="99999999999.99"
          maxlength="14"
          focusSelect
        />
      </div>
      <div [attr.automation-id]="'calculatorModalYearly' | qaSlug">
        <label for="yearlyPayment" class="control-label mb-2">Yearly Payment</label>
        <p-inputNumber
          id="yearlyPayment"
          formControlName="yearlyPayment"
          styleClass="form-control input-span w-100 mb-3"
          mode="currency"
          placeholder="$0.00"
          currency="USD"
          locale="en-US"
          [min]="0"
          [max]="99999999999.99"
          maxlength="14"
          focusSelect
        />
      </div>
    </form>
    <ng-template pTemplate="footer">
      <div class="d-flex justify-content-end gap-2">
        <div [attr.automation-id]="'btnCancelCalculatorModal' | qaSlug">
          <p-button (click)="closeCalculatorModal()" label="Cancel" severity="secondary" />
        </div>
        <div [attr.automation-id]="'btnOkCalculatorModal' | qaSlug">
          <p-button (click)="syncCalculatorModalToExpensesForm()" label="OK" />
        </div>
      </div>
    </ng-template>
  </p-dialog>
  <!-- Modal: Subordinate Financing -->
  <p-dialog
    header="Subordinate Financing"
    [(visible)]="showSubFiModal"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    styleClass="expenses-dialog"
  >
    <form [formGroup]="subFiModalForm">
      <div class="row mb-3">
        <div class="col-4" [attr.automation-id]="'subFiType' | qaSlug">
          <label for="subFiType" class="control-label mb-2 w-100">Sub Fi Type</label>
          <p-select
            #subFiTypeInput
            id="subFiType"
            [options]="subFiTypes"
            placeholder="Select"
            [optionLabel]="'name'"
            [optionValue]="'id'"
            formControlName="subFiType"
            styleClass="w-100"
            (onChange)="calculateHcltv(vm.loan)"
            appendTo="body"
          />
        </div>
        <div class="col-4" [attr.automation-id]="'subFiBaseLoan' | qaSlug">
          <label for="subFiBaseLoan" class="control-label mb-2">Loan Amount</label>
          <p-inputNumber
            id="subFiBaseLoan"
            formControlName="subFiBaseLoan"
            styleClass="form-control input-span"
            placeholder="$0.00"
            mode="currency"
            currency="USD"
            locale="en-US"
            [min]="0"
            [max]="99999999999.99"
            maxlength="14"
            (onBlur)="calculateSubFiPI()"
            focusSelect
          />
        </div>
        <div class="col-4" [attr.automation-id]="'subFiIntRate' | qaSlug">
          <label for="subFiIntRate" class="control-label mb-2">Interest Rate</label>
          <cmg-decimal-input
            id="subFiIntRate"
            formControlName="subFiIntRate"
            (onBlur)="calculateSubFiPI()"
            placeholder="0.000"
            fractionDigits="3"
            type="percent"
            max="100"
            min="0"
            styleClass="form-control input-span w-100"
          />
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-4" [attr.automation-id]="'subFiTerm' | qaSlug">
          <label for="subFiTerm" class="control-label mb-2">Terms In Months</label>
          <p-inputNumber
            id="subFiTerm"
            formControlName="subFiTerm"
            styleClass="form-control input-span"
            [min]="0"
            [minFractionDigits]="2"
            (onBlur)="calculateSubFiPI()"
            focusSelect
          />
        </div>
        <div class="col-4" [attr.automation-id]="'calculatedPi' | qaSlug">
          <label for="calculatedPi" class="control-label mb-2">Calculated P & I</label>
          <p-inputNumber
            id="calculatedPi"
            formControlName="calculatedPi"
            styleClass="form-control input-span"
            mode="currency"
            currency="USD"
            locale="en-US"
            [min]="0"
            [max]="99999999999.99"
            maxlength="14"
            focusSelect
          />
        </div>
        <div class="col-4" [attr.automation-id]="'subFiIntOnly' | qaSlug">
          <div class="mb-2" style="height: 16px"></div>
          <div class="checkbox-container">
            <p-checkbox id="subFiIntOnly" formControlName="subFiIntOnly" inputId="subFiIntOnly" (onChange)="calculateSubFiPI()" [binary]="true" />
            <label>Calculate as interest only</label>
          </div>
        </div>
      </div>
      @if (subFiModalForm.get('subFiType').value === 1) {
        <div class="row mb-3">
          <div class="col-4" [attr.automation-id]="'helocMaxBalance' | qaSlug">
            <label for="helocMaxBalance" class="control-label mb-2">HELOC Credit Limit</label>
            <p-inputNumber
              id="helocMaxBalance"
              formControlName="helocMaxBalance"
              styleClass="form-control input-span"
              placeholder="$0.00"
              mode="currency"
              currency="USD"
              locale="en-US"
              [min]="0"
              [max]="99999999999.99"
              maxlength="14"
              (onBlur)="calculateHcltv(vm.loan)"
              focusSelect
            />
          </div>
          <div class="col-4" [attr.automation-id]="'hcltv' | qaSlug">
            <label for="hcltv" class="control-label mb-2">HCLTV</label>
            <p-inputNumber
              id="hcltv"
              formControlName="hcltv"
              styleClass="form-control input-span"
              mode="decimal"
              [min]="0"
              [maxFractionDigits]="2"
              focusSelect
            />
          </div>
          <div class="col-4"></div>
        </div>
      }
      <div [attr.automation-id]="'excludeSubFi' | qaSlug">
        <div class="checkbox-container">
          <p-checkbox id="excludeSubFi" formControlName="excludeSubFi" [inputId]="'excludeSubFi' | qaSlug" [binary]="true" />
          <label [for]="'excludeSubFi' | qaSlug"
            >Exclude the subordinate loan amount from the 'cash from/to borrower' calculation on the details of transaction</label
          >
        </div>
      </div>
    </form>
    <ng-template pTemplate="footer">
      <div class="d-flex justify-content-end gap-2">
        <div [attr.automation-id]="'btnCancelSubFiModal' | qaSlug">
          <p-button (click)="closeSubFiModal()" label="Cancel" severity="secondary" />
        </div>
        <div [attr.automation-id]="'btnAddSubFiModal' | qaSlug">
          <p-button (click)="syncSubFiModalToLoanStore(vm.subordinateFinancing)" label="Add" />
        </div>
      </div>
    </ng-template>
  </p-dialog>
}
